import React, { useEffect, useRef } from "react";

const W = 1600;
const H = 900;
const wave = (y, amp, phase) => {
  let d = `M -100 ${y}`;
  for (let x = -100; x <= W + 100; x += 50) d += ` L ${x} ${(y + Math.sin((x / W) * Math.PI * 2.2 + phase) * amp).toFixed(1)}`;
  return d;
};
const GROUPS = [
  [[300, 70, 0], [340, 80, 0.6]],
  [[480, 90, 1.8], [520, 70, 2.4]],
  [[660, 60, 3.6], [700, 85, 4.1]],
];

export default function LoginScene() {
  const ref = useRef(null);
  useEffect(() => {
    const root = ref.current?.closest(".lg-root");
    if (!root || window.matchMedia("(prefers-reduced-motion: reduce)").matches || window.matchMedia("(pointer: coarse)").matches) return;
    let raf = 0;
    const onMove = (e) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        root.style.setProperty("--mx", `${e.clientX}px`);
        root.style.setProperty("--my", `${e.clientY}px`);
      });
    };
    window.addEventListener("pointermove", onMove);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("pointermove", onMove); };
  }, []);

  return (
    <div ref={ref} className="lg-scene" aria-hidden="true">
      <div className="lg-blob lg-blob-a" />
      <div className="lg-blob lg-blob-b" />
      <div className="lg-blob lg-blob-c" />
      <div className="lg-floor" />
      <svg className="lg-waves" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="xMidYMid slice">
        <defs>
          <linearGradient id="lg-stroke" x1="0" x2="1">
            <stop offset="0" stopColor="#c4b5fd" stopOpacity="0" />
            <stop offset="0.5" stopColor="#c4b5fd" stopOpacity="0.9" />
            <stop offset="1" stopColor="#8b5cf6" stopOpacity="0" />
          </linearGradient>
        </defs>
        {GROUPS.map((g, gi) => (
          <g key={gi} className="lg-wave-group">
            {g.map(([y, amp, ph], i) => (
              <g key={i}>
                <path d={wave(y, amp, ph)} className="lg-wave lg-wave-base" />
                <path d={wave(y, amp, ph)} className="lg-wave lg-wave-glow" pathLength="1620" style={{ animationDelay: `${-(gi * 2 + i) * 1.7}s` }} />
              </g>
            ))}
          </g>
        ))}
      </svg>
      <div className="lg-spot" />
      <div className="lg-vignette" />
      <div className="lg-grain" />
    </div>
  );
}
